import { render, staticRenderFns } from "./clone-dialog.vue?vue&type=template&id=08dc2962&scoped=true"
import script from "./clone-dialog.vue?vue&type=script&lang=js"
export * from "./clone-dialog.vue?vue&type=script&lang=js"
import style0 from "./clone-dialog.vue?vue&type=style&index=0&id=08dc2962&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dc2962",
  null
  
)

export default component.exports